import { ROLES_ACTIONS } from 'constants/Actions/Roles';

// Estado inicial del reducer
const aInitialState = {
    oRole: null,

    aAllRoles: [],
    aAllTasks: [],

    bIsError: false,
    bIsSuccess: false,
}
/**
 * Reducer que sera utilizado para controlar los datos referidos a los roles del sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const RoleReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case ROLES_ACTIONS.GET:
            return { ...aState, aAllRoles: oAction.data };
        case ROLES_ACTIONS.FIND:
            return { ...aState, oRole: oAction.data };
        case ROLES_ACTIONS.GET_TASKS:
            return { ...aState, aAllTasks: oAction.data };
        case ROLES_ACTIONS.SUCCESS:
            return { ...aState, bIsSuccess: true };
        case ROLES_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        case ROLES_ACTIONS.CLEAN:
            return { ...aState, bIsSuccess: false, bIsError: false, oRole: null };
        default:
            return aState;
    }
}
